import React, { useEffect, useState, useCallback } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaCog,
  FaChartLine,
  FaBoxes,
  FaHeadset,
  FaRegFileAlt,
  FaHandHoldingUsd,
  FaCartArrowDown,
  FaRegCommentDots,
  FaBoxOpen,
  FaWarehouse,
  FaTools,
  FaClipboardList,
  FaBlog,
} from "react-icons/fa";

import { Link, useLocation } from "react-router-dom";
import "./styles/sidebar.css";
import { refreshData } from "../../services/apiService";

import AdminDashboard from "./Dashboard";
import Adminproducts from "./products/Adminproducts";
import UsersTabs from "./allusers/userstab";
import Customers from "./customers/Customers";
import InventoryTabs from "./Inventory/Inventory";
import Reports from "./Reports/reports";
import WareHouse from "./warehouse/WareHouse";
import Discounts from "./discounts/discountstab";
import RazorPayOrders from "./accounting/accounting";
import ProductComments from "./comments/comments";
import AdminOrdersTab from "./adminorders/adminorderstab";
import AdminProfile from "./admin-profile/adminprofile";

import logo from "../../assets/logo.png";

import { FiRefreshCw } from "react-icons/fi";
import { showSnackbar } from "../../comopnents/snackbar";
import ServiceCenters from "./ServiceCenters/ServiceCenters";
import TeleCall from "./telecalling/teleCall";
import Warranty from "./warranty/Warranty";

import Warrantytab from "./warranty/warrantytab";

import VerificationList from "./VerificationList";

import BlogsTab from "./Blogs/blogstab";
const menuItems = [
  { name: "Dashboard", module: "dashboard", icon: <FaTachometerAlt /> },
  { name: "Users", module: "module_settings", icon: <FaUsers /> },
  { name: "Products", module: "products", icon: <FaBoxes /> },
  { name: "Customers", module: "customers", icon: <FaUsers /> },
  { name: "Service Centers", module: "Service Centers", icon: <FaTools /> },
  { name: "Inventory", module: "inventory", icon: <FaCartArrowDown /> },
  { name: "Reports", module: "reports", icon: <FaChartLine /> },
  { name: "Orders", module: "orders", icon: <FaBoxOpen /> },
  { name: "Warehouse", module: "warehouse", icon: <FaWarehouse /> },
  { name: "Discounts", module: "discount", icon: <FaHandHoldingUsd /> },
  { name: "Warranty", module: "warranty", icon: <FaRegFileAlt /> },
  { name: "Verification List", module: "verification", icon: <FaClipboardList /> },
  { name: "Telecalling", module: "telecalling", icon: <FaHeadset /> },
  { name: "Accounting", module: "accounting", icon: <FaRegFileAlt /> },
  { name: "Comments", module: "comments", icon: <FaRegCommentDots /> },
  { name: "Settings", module: "settings", icon: <FaCog /> },
  { name: "Blogs", module: "Blogs", icon: <FaBlog /> },
];

const AdminPanel = () => {
  const [active, setActive] = useState("Dashboard");
  const location = useLocation();

  useEffect(() => {
    if (location.state?.activeSection) {
      setActive(location.state.activeSection);
    }
  }, [location.state]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleMouseEnter = useCallback(() => setIsExpanded(true), []);
  const handleMouseLeave = useCallback(() => setIsExpanded(false), []);

  const modules = (localStorage.getItem("modules") || "")
    .toLowerCase()
    .split(",");

  const userType = localStorage.getItem("userType");

  // SuperAdmin can see everything
  const allowedMenu =
    userType === "SuperAdmin"
      ? menuItems
      : menuItems.filter((item) => modules.includes(item.module));

  const renderContent = () => {
    switch (active) {
      case "Dashboard":
        return <AdminDashboard />;

      case "Users":
        return <UsersTabs />;

      case "Products":
        return <Adminproducts />;

      case "Customers":
        return <Customers />;

      case "Service Centers":
        return <ServiceCenters />;

      case "Inventory":
        return <InventoryTabs />;

      case "Reports":
        return <Reports />;

      case "Warehouse":
        return <WareHouse />;

      case "Warranty":
        return <Warrantytab />;

      case "Verification List":
        return <VerificationList />;

      case "Orders":
        return <AdminOrdersTab />;

      case "Discounts":
        return <Discounts />;

      case "Telecalling":
        return <TeleCall />;

      case "Accounting":
        return <RazorPayOrders />;

      case "Comments":
        return <ProductComments />;

      case "Blogs":
        return <BlogsTab />;

      case "Settings":
        return <AdminProfile />;

      default:
        return <p>Select a section.</p>;
    }
  };

  useEffect(() => {
    console.log("allowedMenu:", allowedMenu);
  }, [allowedMenu]);


  const handleRefresh = async () => {
    try {
      setLoading(true);
      const data = await refreshData();
      console.log("Refresh response:", data);

      showSnackbar("success", "Cache updated successfully!");
    } catch (error) {
      console.error("Refresh error:", error);
      showSnackbar("error", "Failed to update cache.");
    } finally {
      setLoading(false);
    }
  }; 

  return (
    <div className="admin-container">
      {/* Sidebar */}
      <div
        className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="sidebar-logo">
          <span className="logo-text">Admin Panel</span>
        </div>

        <ul className="sidebar-menu">
          {allowedMenu.map((item) => (
            <li
              key={item.name}
              className={`menu-item ${active === item.name ? "active" : ""}`}
              onClick={() => setActive(item.name)}
            >
              <span className="iconadmin">{item.icon}</span>
              <span className="menu-text">{item.name}</span>
            </li>
          ))}
        </ul>

        <div className="sidebar-footer">
          <span className="role-text">
            Hi {localStorage.getItem("userType") || "User"}
          </span>
        </div>
      </div>

      {/* Right Section */}
      <div
        className="right-section"
        style={{
          marginLeft: isExpanded ? "220px" : "60px",
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* Header */}
        <div className="admin-header">
          <div className="logo">
            <Link to="/" style={{ textDecoration: "none" }}>
              <img
                src={logo}
                alt="PIXEL"
                className="logo-img"
                style={{ width: "100px" }}
              />
            </Link>
          </div>

          <div className="search-bar">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <FiRefreshCw
              onClick={handleRefresh}
              style={{
                cursor: "pointer",
                fontSize: "24px",
                color: loading ? "#999" : "#005487",
                marginTop: "10px",
              }}
              title={loading ? "Refreshing..." : "Refresh"}
            />
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="content-box">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;